import React from "react";
import "./style.css";

const Footer = () => {
  return (
    <>
      <footer>
        <div className="container grid2">
          <div className="box">
            <h1 className=" tracking-wider text-2xl">SIKDAR</h1>

            <p>
             I created this eCommerce website for learning purpose . I Can Develop
  any kind of Front-End website.If you like my work, please contact with me.
            </p>

            <div>
              <h3 className="text-gray-200">
                Technology Used For Making This E-Commerece :{" "}
              </h3>
              <p>React JS, Tailwind, Node JS, HTML, CSS And Other</p>
            </div>

            <div className="icon d_flex">
              <div className="img d_flex">
                <i class="fa-brands fa-google-play"></i>
                <span className="text-sm cursor-pointer">Google Play</span>
              </div>
              <div className="img d_flex">
                <i class="fa-brands fa-app-store-ios"></i>
                <span className="text-sm cursor-pointer">App Store</span>
              </div>
            </div>
          </div>

          <div className="box ml-10 ">
            <h2 className=" font-bold text-2xl font-serif">About Us</h2>
            <ul>
              <li className=" cursor-pointer">Careers</li>
              <li className=" cursor-pointer">Our Stores</li>
              <li className=" cursor-pointer">Our Cares</li>
              <li className=" cursor-pointer">Terms & Conditions</li>
              <li className=" cursor-pointer">Privacy Policy</li>
            </ul>
          </div>
          <div className="box">
            <h2 className=" font-bold text-2xl font-serif">Customer Care</h2>
            <ul>
              <li className=" cursor-pointer">Help Center </li>
              <li className=" cursor-pointer">How to Buy </li>
              <li className=" cursor-pointer">Track Your Order </li>
              <li className=" cursor-pointer">Corporate & Bulk Purchasing </li>
              <li className=" cursor-pointer">Returns & Refunds </li>
            </ul>
          </div>
          <div className="box">
            <h2 className=" font-bold text-2xl font-serif">Contact Us</h2>
            <ul>
              <li>Gazipur Sadar,Gazipur,Dhaka</li>
              <li>Email: parvejsikder4433@gmail.com</li>
              <li>Phone: +8801303569312</li>
            </ul>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
